import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";
import Slider from "./../slider/Slider.vue";
import moment from "moment";
import "moment/locale/pl";

export default {
  name: "PeopleCard",
  components: {
    Header,
    Footer,
    People: require("../people/People.vue").default,
    Slider
  },
  data() {
    return {
      peopleData: {},
      firstSix: [],
      hideBtn: false
    };
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("LL");
      }
    },
    truncate: function(text, stop) {
      return text.slice(0, stop);
    }
  },
  methods: {
    getData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/wp/v2/posts?categories=6&_embed&per_page=100"
        )
        .then(function(data) {
          this.peopleData = JSON.parse(JSON.stringify(data)).body;
          console.log(this.peopleData);
          this.showNews();
        });
    },

    showNews() {
      if (this.peopleData.length > 6) {
        for (let people of this.peopleData) {
          if (this.firstSix.length < 6) this.firstSix.push(people);
        }
      } else {
        this.firstSix = this.peopleData;
        this.hideBtn = true;
      }
    },

    showMoreNews() {
      let newsIndex = this.firstSix.length;
      let index = newsIndex;
      while (this.firstSix.length < newsIndex + 6) {
        if (index < this.peopleData.length) {
          this.firstSix.push(this.peopleData[index]);
        } else {
          this.hideBtn = true;
          break;
        }
        index = index + 1;
      }
      if (this.firstSix.length == this.peopleData) this.hideBtn = true;
    }
  },
  created() {
    this.getData();
  }
};
